module.exports = __webpack_public_path__ + "static/src/nrl-teams/images/eels.728d650.png";


//////////////////
// WEBPACK FOOTER
// ./src/nrl-teams/images/eels.png
// module id = 3l6n
// module chunks = 0